import Long from 'long';

import RawMessagesStore from './RawMessagesStore';
import WorkspaceStore from '../Workspaces/WorkspaceStore';

interface IMessagesPool {
  getMessagesStore: (channelID: Uint8Array, chatID: Long) => RawMessagesStore;
}

export default class MessagesPool implements IMessagesPool {

  constructor(protected workspace: WorkspaceStore) {
  }
  
  private messagesStores_: {[chatId: string]: RawMessagesStore} = {};
  
  public getMessagesStore = (channelID: Uint8Array, chatID: Long, lastMessageId?: Long | null): RawMessagesStore => {
    if (!this.messagesStores_[chatID.toString()]) {
      this.messagesStores_[chatID.toString()] = new RawMessagesStore(
        this.workspace,
        channelID,
        chatID,
        lastMessageId,
        this.workspace.app.userStore.user?.userId,
      );
    }

    return this.messagesStores_[chatID.toString()];
  };

  public reset = () => {
    console.debug(`%c----->MessagesPool.reset`, 'color: gray');
    for (const key in this.messagesStores_) {
      this.messagesStores_[key].destroy();
    }
    this.messagesStores_ = {};
  };
}
